import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { ContatoCliente } from '../api/dto/contato-cliente';

@Injectable({
    providedIn: 'root',
})
export class ContatoClienteService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'contatos-clientes/';


    listarPorClienteId(clienteId?: number): Observable<ContatoCliente[]> {
        return this.http.get<ContatoCliente[]>(this.url + 'cliente/' + clienteId);
    }

    salvar(contatoCliente?: ContatoCliente): Observable<ContatoCliente> {
        return this.http.post<ContatoCliente>(this.url, contatoCliente);
    }

    salvarLista(contatosCliente?: ContatoCliente[]): Observable<ContatoCliente[]> {
        return this.http.post<ContatoCliente[]>(this.url + 'lista', contatosCliente);
    }

    atualizar(id?: number, contatoCliente?: ContatoCliente): Observable<ContatoCliente> {
        return this.http.put<ContatoCliente>(this.url + id, contatoCliente);
    }

    excluir(contatoId?: number): Observable<void> {
        return this.http.delete<void>(this.url + contatoId);
    }

}